import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function extractError(error) {
  return formatApiErrorDetail(error?.response?.data?.detail) || error?.message || "Network error";
}

export function isSubscriptionRequiredError(error) {
  const detail = extractError(error).toLowerCase();
  return error?.response?.status === 402 || detail.includes("subscription required");
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isSubscriptionRequiredError(error) && typeof window !== "undefined") {
      const pathname = window.location.pathname;
      const isSubscriptionPage = pathname === "/app/subscription" || pathname.startsWith("/app/subscription/");
      if (!isSubscriptionPage) {
        window.location.assign("/app/subscription");
      }
    }
    return Promise.reject(error);
  }
);
